import type { Payment } from '../types/payment.types'

export const mockPayments: Payment[] = [
    {
        id: 'PAY-001',
        orderId: 'ORD-001',
        customer: 'John Doe',
        merchant: 'ABC Building Supplies',
        amount: 15000,
        method: 'upi',
        status: 'success',
        transactionId: 'TXN123456789',
        createdAt: '2024-12-15',
        gatewayResponse: 'Payment successful',
        upiId: 'john@paytm',
    },
    {
        id: 'PAY-002',
        orderId: 'ORD-002',
        customer: 'Jane Smith',
        merchant: 'XYZ Materials',
        amount: 95000,
        method: 'card',
        status: 'success',
        transactionId: 'TXN987654321',
        createdAt: '2024-12-20',
        gatewayResponse: 'Payment successful',
        cardLast4: '4242',
    },
    {
        id: 'PAY-003',
        orderId: 'ORD-003',
        customer: 'Bob Wilson',
        merchant: 'DEF Supplies',
        amount: 25000,
        method: 'netbanking',
        status: 'failed',
        transactionId: 'TXN456789123',
        createdAt: '2024-12-22',
        gatewayResponse: 'Insufficient funds',
    },
]
